module.exports = __webpack_public_path__ + "media/images/orange_search-d62af8cf616c36740e6b7a8eef6568d8.svg";